import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import Button from 'grommet/components/Button';
//import Heading from 'grommet/components/Heading';
import $ from 'jquery';
import renderHTML from 'react-render-html';
import html2canvas from 'html2canvas';
import  jsPDF from 'jspdf';
import { connect } from 'react-redux';
import {fetchConfigString,downloadFile} from '../../State/actions/sessions';
import {serviceUrl,said} from '../../AppConfig';
//let TreevieeLevel1;
var StringX;
var StringY;
var StringZ;

class ConfigurationDetails extends Component{
  constructor(){
      super();
      this.state={         
      }
        this.onBomSavePdf=this.onBomSavePdf.bind(this);
        this.ObjectLoopingCommonfn=this.ObjectLoopingCommonfn.bind(this);
        this.exportConfig = this.exportConfig.bind(this);
  }

  componentDidMount(){
      if (this.props.activeSession.configView == '') {
          let sessionObject;
          if (this.props.actvSoln === undefined || this.props.actvSoln === null) {
              sessionObject = { "SessionID": this.props.activeSession.id };
          } else {
              //var sessionObject = {"SessionID":this.props.activeSession.id };//Rohith-Removed Traditional from backend
              sessionObject = { "SessionID": this.props.activeSession.id, "EPASolutionType": this.props.actvSoln.toString() };
          }
          this.props.onFetchConfigString(sessionObject);
      }
  }

  exportConfig(format)
  {
    //commented by dheeraj as this way of download doesnot surpport to add token to header
    //   var mapForm = document.createElement("form");
            
    //         mapForm.id = "FormExportBOM";

    //         mapForm.setAttribute("method","GET")
    //         mapForm.setAttribute("action", serviceUrl+"/SizingEngine/ConfigDoc");

    //         mapForm.target = "_blank";

    //         var mapInput1 = document.createElement("input");
    //         mapInput1.id = "BomHTMLTemp1";
    //         mapInput1.type = "text";
    //         mapInput1.name = "format";
    //         mapInput1.value = format.toString();
    //         mapForm.appendChild(mapInput1);

    //         var mapInput = document.createElement("input");
    //         mapInput.id = "BomHTMLTemp";
    //         mapInput.type = "text";
    //         mapInput.name = "sessionId";
    //         mapInput.value = this.props.activeSession.id.toString();

    //         mapForm.appendChild(mapInput);


    //          if(said === 'EPA')
    //         {
    //             var mapInput2 = document.createElement("input");
    //             mapInput2.id = "BomHTMLTemp";
    //             mapInput2.type = "text";
    //             mapInput2.name = "EPASolutionType";
    //             mapInput2.value = null;
    //             if(this.props.actvSoln !== null)
    //             {
    //                 mapInput2.value = this.props.actvSoln.toString();
    //             }
    //             mapForm.appendChild(mapInput2);
    //         }

    //         document.body.appendChild(mapForm);
    //          mapForm.submit();
    //          $("#FormExportBOM").remove();

      let exportUrl;
      if (this.props.actvSoln) {
          exportUrl = serviceUrl + "/SizingEngine/ConfigDoc?format=" + format.toString() + "&sessionId=" + this.props.activeSession.id.toString() + "&EPASolutionType=" + this.props.actvSoln.toString();
      } else {
          exportUrl = serviceUrl + "/SizingEngine/ConfigDoc?format=" + format.toString() + "&sessionId=" + this.props.activeSession.id.toString();
      }

      var data = {
          url: exportUrl,
          name: 'ConfigurationDetails.' + format.toString()
      }

      this.props.onConfigDetailsExport(data);

  }

  onBomSavePdf(){
      html2canvas(document.querySelector("#ConfigureDetails")).then(canvas => {
     const imgData = canvas.toDataURL('image/png');
      var     doc;
       if(canvas.width > canvas.height){
             doc = new jsPDF('l', 'mm', [380, canvas.height]);
              doc.addImage(imgData, 'JPEG', 15, 15);
               }
           else{
             doc = new jsPDF('p', 'mm', [380, canvas.width]);
                doc.addImage(imgData, 'JPEG', 15, 15);
            
          }
         doc.save("ConfigurationDetails.pdf");


        //         var doc = new jsPDF({unit:'px'});
        //          doc.setFontSize(20);
        //         //  doc.text(10, 10, "Configuration Details");
        //          doc.addImage(imgData, 'JPEG', 15, 15, 400, 700);
        //         doc.save("ConfigurationDetails.pdf");

        });
    //   html2canvas(document.querySelector("#ConfigureDetails")).then(canvas => {
    //  const imgData = canvas.toDataURL('image/png');
    //     const pdf = new jsPDF();
    //     pdf.addImage(imgData, 'JPEG', 15, 20, 190, 300);
    //     // pdf.output('dataurlnewwindow');
    //     pdf.save("Configuration Details.pdf");
    //   //  this.downloadPDF(canvas.toDataURL(), 'canvas.pdf');
    // });
 
}

 ObjectLoopingCommonfn(loopObject1){
                  //TreevieeLevel1 = loopObject1.map(function(val,id){
                            
                  //          return(<ul>
                  //          <li><span>{val["RoleName"]}</span><ul>
                  //              <li><span>{val["Processor"]}</span><ul>
                  //                  <li><span>{val["Storage"]}</span></li>
                  //                  <li><span>Memory - (Per Server)</span></li>
                  //                  <li> <span>GB Storage</span></li>
                  //              </ul></li>
                  //          </ul></li>
                  //          </ul>)
                                    
                  //      });
}

    render(){
        var loopObject;
        var ObjectArray;
      if(this.props.activeSession.configView["configuration"] ==undefined ||this.props.activeSession.configView["configuration"]==''){
          StringX='';
          StringY='';
          StringZ='';
      }else{
           StringX=$('<div />').html(this.props.activeSession.configView["ConfigDatasize"]).text();
           StringY=$('<div />').html(this.props.activeSession.configView["treeView"]).text();
           StringZ=$('<div />').html(this.props.activeSession.configView["configuration"]).text();   
         
      }
       loopObject = this.props.activeSession.treeView.Solutions.Solution.Roles.Role;
               if( Array.isArray(loopObject)){
                   this.ObjectLoopingCommonfn(loopObject);
               }else{
                  ObjectArray=[];
                  ObjectArray.push(loopObject)
                    this.ObjectLoopingCommonfn(ObjectArray);
               } 

  


    //  StringY=this.props.activeSession.configView["treeView"];
        return(
              <Box id="ConfigureDetails" style={{width:'100%',position:'relative',marginTop:'27px'}} margin="none" pad="none" className="StringSection">             
                    
                        
                            {renderHTML(StringX)}
                            { /*<Heading tag="h4" strong={true} size='small' style={{marginTop:'25px',fontSize: '17px'}}>Solution Summary</Heading>*/}
                          { /* <ul className="treeViewItem">                            
                          <li>Solution Details {TreevieeLevel1}</li></ul> */}
                            {renderHTML(StringY)}
                            {renderHTML(StringZ)}                    
                            
                    <Box direction='row' margin="none" pad={{between:"small"}} className="StringSection " alignSelf="start" align="start" alignContent="start" style={{marginLeft:'1%',marginTop:'10px' ,marginBottom:'10px'}}>            
                        <Button primary={false} label='Save as PDF'  onClick={()=>this.exportConfig('pdf') }/>
                        <Button primary={false} label='Save as Word' onClick={()=>this.exportConfig('doc')} />
                         {/* <Button primary={false} label='Open in mail' />*/}
                   </Box>  
             </Box>

        );
    }
}

const mapStateToProps = (state) => {  
  return{                
      activeSession: state.sessions.activeSession,
  };
};

const mapDispatchToProps = (dispatch) => {
    return {
   onFetchConfigString:(sessionID) =>{
        dispatch(fetchConfigString(sessionID));
      },
   onConfigDetailsExport:(data) =>{
       dispatch(downloadFile(data));
   }
    };
};

export default connect(mapStateToProps,mapDispatchToProps) (ConfigurationDetails);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/ConfigurationDetails.js